import React from "react";

import { Form, Input, Select, DatePicker } from "antd";

const InputByType = ({ 
    type, 
    typeValues,
    mode,
    maxTagCount,
    ...restProps 
}) => {
    switch( type ){
        case "text":
            return <Input {...restProps} /> ;
        case "select":
            return <Select options={typeValues} mode={mode} maxTagCount={maxTagCount} className="w-100" {...restProps} /> ;
        case "date":
            return <DatePicker format="DD/MM/YYYY" showNow={false} {...restProps} /> ;
        default:
            return <Input {...restProps} /> ;
    }
}

// const getTitleText = (title) => {
//     if( typeof title === 'string' ) return title;
//     if( typeof title === 'number' ) return String(title);
//     if( Array.isArray(title) ) return title.map(getTitleText).join(' ');
//     if( title && title.props && title.props.children ) {
//       return getTitleText(title.props.children);
//     }
//     return '';
// };

export const TableCell = ({
    inputType,
    inputValues,
    dataIndex,
    title,
    editing,
    display,
    mode,
    maxTagCount,
    required = true,
    children,
    ...restProps 
}) => {
    // const titleText = getTitleText(title);
    return(
        <td {...restProps}>
            {
                editing && display
                ?
                    <Form.Item
                        name={dataIndex}
                        className="mb-0"
                        rules={[
                            { required, message: `Obligatoire` }
                        ]}
                    >
                        <InputByType type={inputType} typeValues={inputValues} mode={mode} maxTagCount={maxTagCount} />
                    </Form.Item>
                :
                    children
            }
        </td>
    );
}